exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EventsEmbedConfigurator-1bfb2369{display:flex;border-bottom:1px solid #DEDEDE}.LeftPanel-55898f94{flex:1;min-width:0;max-width:450px;padding-top:40px;padding-bottom:20px;border-right:1px solid #eee}.LeftPanel-55898f94 pre .embedCode-821111b8{white-space:pre-wrap;width:100%;height:100px}.Preview-0f8223af{background-color:#f5f5f5;flex:2;min-width:0;padding:40px 80px;position:relative}.Preview-0f8223af .embed-c6f483cc{border:2px solid #E0E0E0;border-radius:6px;height:70vh;overflow:scroll}.section-80597c41{margin-bottom:30px;padding-left:20px;padding-right:20px}.swatch-5c931eb2{height:35px;width:35px;display:block;border-radius:4px}a.listButton-2f9eecbe{margin:0;margin-right:20px}.embedCode-821111b8{width:100%;height:150px;padding:10px}\n", ""]);

// Exports
exports.locals = {
	"EventsEmbedConfigurator": "EventsEmbedConfigurator-1bfb2369",
	"LeftPanel": "LeftPanel-55898f94",
	"embedCode": "embedCode-821111b8",
	"Preview": "Preview-0f8223af",
	"embed": "embed-c6f483cc",
	"section": "section-80597c41",
	"swatch": "swatch-5c931eb2",
	"listButton": "listButton-2f9eecbe"
};